const BASE_URL = "https://pms.api.algosu.com";
const S3_BASE_URL = "https://pms-project-s3.s3.ap-south-1.amazonaws.com";
const REACT_APP_RECAPTCHA_SITE_KEY = "6LdGkjMrAAAAAOxf3ll3X9VM0A8YaGINUGPwon6p";
const RAZORPAY_KEY_ID = "rzp_test_sr3wB2DUqTVLDg";
const UPMYTEAM_BASE_URL = "https://api.upmyteam.com";

export {
  BASE_URL,
  S3_BASE_URL,
  REACT_APP_RECAPTCHA_SITE_KEY,
  RAZORPAY_KEY_ID,
  UPMYTEAM_BASE_URL,
};
